import React from "react";
import { PhoneCall, Mail } from "react-feather";
import PostApiCall from "../Api/Api";
import GetApiCall from "../Api/GetApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import "../assets/scss/plugins/extensions/toastr.scss"
import { delay } from "../Helper/ToastDelay";
import Notiflix from "notiflix";
import { invalidEmail, SomethingWrong } from "../Helper/ErrorMessages";
import { BANNER_BG, PRIMARY_TEXT_COLOR } from "../color";

class Contact extends React.Component {
  state = {
    NumRegex: /^[0-9]*$/,
    MobileRegex: /^[0-9]*$/,
    AlphabetRegex: /^[A-Za-z]+$/,
    AlphaNumericRegex: /^[a-zA-Z0-9]*$/,
    SpecialRegex: /[-!$%^&*()_+|~=`'"{}\[\]:\/;<>?,.@#]/,
    EmailRegex:
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    UrlRegex:
      /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,

    Name: "",
    Email: "",
    Mobile: "",
    Message: "",
  };

  OnSubmit() {
    if (this.state.EmailRegex.test(this.state.Email)) {
      // Notiflix.Loading.standard();

      PostApiCall.postRequest(
        {
          name: this.state.Name,
          email: this.state.Email,
          mobile: this.state.Mobile,
          message: this.state.Message,
        },
        "ContactUsMailer"
      ).then((resultdes) =>
        resultdes.json().then((obj) => {
          if (resultdes.status == 200 || resultdes.status == 201) {
            Notiflix.Loading.remove();

            Notiflix.Report.success(
              "Query Sent!",
              "Thankyou for contacting us, We will get back soon.",
              "Ok",
              function () {
                // Yes button callback
                window.location.reload();
              }
            );
          } else {
            Notiflix.Loading.remove();

            toast.error(SomethingWrong, {
              autoClose: delay,
            });
          }
        })
      );
    } else {
      toast.error(invalidEmail, {
        autoClose: delay,
      });
    }
  }

  render() {
    return (
      <div className="App">
        <ToastContainer />
        <header
          id="home"
          className="hero-area"
          style={{
            background: BANNER_BG,
          }}
        >
          <div className="container">
            <div className="row space-100">
              <div className="col-lg-5 col-md-12 col-xs-12 md-order-0 order-1">
                <div className="intro-img">
                  <img src="/assets/img/slider/contactus.png" alt="" />
                </div>
              </div>
              <div className="col-lg-7 col-md-12 col-xs-12 md-order-1 order-0">
                <div className="contents">
                  <h2
                    className="head-title "
                    // style={{ fontSize: "50px", lineHeight: "4rem" }}
                  >
                    Don't let any issue go
                  </h2>
                  <h2
                    className=""
                    style={{ fontSize: "30px", lineHeight: "2rem" }}
                  >
                    unsolved Contact Us !!!
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </header>
        <section id="contact" className="section">
          <div className="contact-form">
            <div className="container">
              <div className="row contact-form-area">
                <div className="col-md-12 col-lg-6 col-sm-12">
                  <div className="quick-form-job text-dark" style={{ marginTop: "0px" }}>
                    <h2>Contact Form</h2>
                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                      }}
                      style={{ border: "1px solid #e8ecec", marginTop: "22px" }}
                    >
                      <input
                        type="text"
                        value={this.state.Name}
                        onChange={(e) => {
                          this.setState({
                            Name: e.target.value,
                          });
                        }}
                        placeholder="Enter your Name *"
                        required
                      />
                      <input
                        type="text"
                        value={this.state.Email}
                        onChange={(e) => {
                          this.setState({
                            Email: e.target.value,
                          });
                        }}
                        placeholder="Email Address*"
                        required
                      />
                      <input
                        type="text"
                        value={this.state.Mobile}
                        onChange={(e) => {
                          if (
                            this.state.NumRegex.test(e.target.value) &&
                            e.target.value.length <= 10
                          ) {
                            this.setState({
                              Mobile: e.target.value,
                            });
                          }
                        }}
                        placeholder="Phone Number"
                      />
                      <textarea
                        rows="5"
                        value={this.state.Message}
                        onChange={(e) => {
                          this.setState({
                            Message: e.target.value,
                          });
                        }}
                        placeholder="Message should have more than 50 characters"
                      ></textarea>
                      <button
                        className="submit send-btn"
                        onClick={() => {
                          this.OnSubmit();
                        }}
                      >
                        Send Email
                      </button>
                      {/* <span style={{ fontSize: '12px' }}>You accepts our <a href="#" title="">Terms and Conditions</a></span> */}
                    </form>
                  </div>
                </div>
                <div className="col-md-12 col-lg-6 col-sm-12">
                  <div className="contact-right-area wow fadeIn">
                    <h2 className="text-dark">Contact Address</h2>
                    <div className="contact-info" >
                      <div className="single-contact">
                        <div className="contact-icon">
                          <i className="lni-map-marker"></i>
                        </div>
                        <p style={{color:PRIMARY_TEXT_COLOR}}>
                         <strong>Main Office:</strong>  C-807, Unitech Business Zone, Golf Course
                          Extn Road, Sector-50, Gurgaon -122018, Haryana, India{" "}
                          <br /> <strong>Innovation Center: </strong>1059, LGF, Sector 47, Sohna
                          Road, Gurgaon-122001, Haryana, India
                        </p>
                      </div>
                      <div className="single-contact">
                        <div className="contact-icon">
                          <i className="lni-envelope"></i>
                        </div>
                        <p >
                          <a style={{color:PRIMARY_TEXT_COLOR}} href="mailto:support@beteljobs.com">
                            support@beteljobs.com
                          </a>
                        </p>
                      </div>
                      <div className="single-contact">
                        <div className="contact-icon">
                          <i className="lni-phone-handset"></i>
                        </div>
                        <p>
                          <a style={{color:PRIMARY_TEXT_COLOR}} href="tel:+919319179297"> +91 9319179297 </a><br/>
                          <a style={{color:PRIMARY_TEXT_COLOR}} href="tel:+911244594949"> +91 1244594949</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div id="conatiner-map">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3509.1915451657183!2d77.07004231455457!3d28.413476600713288!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d226e162c638b%3A0x2d71b175693bd2e4!2sUnitech%20Business%20Zone%2C%20Golf%20Course%20Ext%20Rd%2C%20The%20Close%20South%2C%20Sector%2050%2C%20Gurugram%2C%20Haryana%20122018!5e0!3m2!1sen!2sin!4v1620372419104!5m2!1sen!2sin"
                      width="600"
                      height="450"
                      style={{ border: "0" }}
                      allowfullscreen=""
                      loading="lazy"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Contact;
